var map = {
	"./bg1.png": 55685,
	"./chris150-allPrize.png": 95587,
	"./chris150-bd.png": 80054,
	"./chris150-d1.png": 43660,
	"./chris150-d2.png": 33924,
	"./chris150-d3.png": 15499,
	"./chris20.png": 83133,
	"./chris200-allPrize.png": 69254,
	"./chris200-bd.png": 50663,
	"./chris200-d1.png": 62580,
	"./chris200-d2.png": 36821,
	"./chris200-d3.png": 58018,
	"./chrisBg.png": 11143,
	"./chrisMysteryBox.png": 3733,
	"./chrisMysteryBoxBg.jpg": 25533,
	"./christBg1.png": 66229,
	"./coin10-allPrize.png": 17615,
	"./coin10-bd.png": 92184,
	"./coin10-d1.png": 80180,
	"./coin10-d2.png": 40887,
	"./coin10-d3.png": 13621,
	"./coin100-allPrize.png": 26998,
	"./coin100-bd.png": 49175,
	"./coin100-d1.png": 16435,
	"./coin100-d2.png": 10165,
	"./coin100-d3.png": 57673,
	"./coin100-d4.png": 73149,
	"./coin100-d5.png": 6509,
	"./coin100-d6.png": 73562,
	"./coin15-allPrize.png": 52392,
	"./coin15-bd.png": 16178,
	"./coin15-d1.png": 81417,
	"./coin15-d2.png": 82633,
	"./coin15-d3.png": 27490,
	"./coin15-d4.png": 41864,
	"./coin20-allPrize.png": 62807,
	"./coin20-bd.png": 93695,
	"./coin20-d1.png": 51702,
	"./coin20-d2.png": 58853,
	"./coin20-d3.png": 26387,
	"./coin20-d4.png": 47023,
	"./coin30-allPrize.png": 62513,
	"./coin30-bd.png": 37417,
	"./coin30-d1.png": 39110,
	"./coin30-d2.png": 78816,
	"./coin30-d3.png": 21751,
	"./coin30-d4.png": 12222,
	"./coin30-d5.png": 96229,
	"./coin5-allPrize.png": 70957,
	"./coin5-bd.png": 48059,
	"./coin5-d1.png": 70192,
	"./coin5-d2.png": 61103,
	"./coin50-allPrize.png": 68889,
	"./coin50-bd.png": 1922,
	"./coin50-d1.png": 53314,
	"./coin50-d2.png": 31811,
	"./coin50-d3.png": 5479,
	"./coin50-d4.png": 30780,
	"./coin50-d5.png": 93265,
	"./coinBg.png": 78295,
	"./flowers.gif": 96992,
	"./multi.png": 68937,
	"./mysteryBox.png": 97173,
	"./mysteryBoxBg.jpg": 29753,
	"./mysteryBoxBg2.jpg": 10048,
	"./mysteryBoxHand.gif": 52534,
	"./mysteryBoxHand.png": 36762,
	"./num1.png": 51546,
	"./num10.png": 43385,
	"./num2.png": 28987,
	"./num5.png": 39521,
	"./prizeCoin.png": 7783,
	"./scatterFlowerSprites.png": 90090,
	"./smallMysteryBox.png": 31298,
	"./star1.png": 61454,
	"./star2.png": 708,
	"./windowBg.png": 82316,
	"./windowCoin-chris20.png": 77604,
	"./windowCoin-num1.png": 13880,
	"./windowCoin-num10.png": 83621,
	"./windowCoin-num2.png": 65215,
	"./windowCoin-num5.png": 54968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68710;